<template>
    <div class="company-card">
        <h5 class="card-title" v-if="cardTitle">{{ cardTitle }}</h5>
        <h6><strong>{{ company.name }}</strong></h6>
        <div class="row">
            <div class="col-md-2 col-lg-2">
                <img class="card-img-top" :src="company.picture" :alt="company.name">
            </div>
            <div class="col-md-10 col-lg-10">
                <p v-if="company.description">{{ company.description | truncate(200) }}</p>
                <div class="card-text">
                    <a :href="company.urlname" target="_blank">{{ company.urlname }}</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'company-card',

    props: {
        company: {
            type: Object,
            default() {
                return {};
            }
        },

        cardTitle: {
            type: String,
            default: ''
        }
    }
}
</script>

<style lang="scss" scoped>
    .company-card {
        color: #505B64;
        font-size: 15px;
        line-height: 25px;

        h6 {
            color: $grey;
            margin-bottom: 15px;
        }
        .card-img-top {
            max-width: 77px;
            margin: 0 0 15px;
        }
    }
</style>
